import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef
} from "@angular/core";
import { MenuInput, MenuSectionInput, MenuItemInput } from 'src/app/core/api/api';
import { IPlace } from 'src/app/shared/interfaces';
import { DownloadModalComponent } from 'src/app/shared/components/download-modal/download-modal.component';
import { environment } from 'src/environments/environment.prod';
import {
  faCocktail,
  faUtensils,
  faCoffee,
  faFrenchFries,
  faBurgerSoda,
  faHamburger,
  faPizzaSlice,
  faGlassCitrus,
  faGlassCheers,
  faWineBottle,
  faMugHot,
  faMeat,
  faFishCooked,
  faCheeseSwiss,
  faCroissant,
  faSoup,
  faSalad,
  faPepperHot,
  faAppleAlt,
  faCarrot,
  faIceCream,
  faPercent,
  faBook
} from '@fortawesome/pro-light-svg-icons';
import { EntityColourScheme } from "src/app/core/models/entity";
import * as Color from "color";
import { MatDialog } from "@angular/material/dialog";


@Component({
  selector: "ping-menu",
  templateUrl: "./menu.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./menu.component.scss"]
})
export class MenuComponent {
  @Input() menu: MenuInput;
  @Input() entity: IPlace;
  @Input() colourScheme: EntityColourScheme;

  primaryColourText: string;
  secondaryColourText: string;

  public currentSection: MenuSectionInput;
  public sectionTitle: string;
  imageurl = environment.aws.s3Url + 'entities/100/';

  // Icons
  public icons: any = {
    utensils : faUtensils,
    hamburger : faHamburger,
    french_fries : faFrenchFries,
    burger_soda : faBurgerSoda,
    pizza_slice : faPizzaSlice,
    cocktail : faCocktail,
    glass_citrus : faGlassCitrus,
    glass_cheers : faGlassCheers,
    wine_bottle : faWineBottle,
    coffee : faCoffee,
    mug_hot : faMugHot,
    meat : faMeat,
    fish_cooked : faFishCooked,
    cheese_swiss : faCheeseSwiss,
    croissant : faCroissant,
    soup : faSoup,
    salad : faSalad,
    apple_alt: faAppleAlt,
    pepper_hot : faPepperHot,
    carrot : faCarrot,
    ice_cream : faIceCream,
    percent: faPercent,
    book: faBook,
  }

  constructor(
    private cd: ChangeDetectorRef,
    private modalService: MatDialog,
  ) {}

  ngOnInit(): void {
    if (this.menu?.sections?.length) {
      this.currentSection = this.menu.sections[0];
      this.sectionTitle = this.currentSection.title;
    }
    if (this.entity?.config?.colourScheme) {
      this.colourScheme = this.entity?.config?.colourScheme;
      this.primaryColourText = this.colourScheme?.primary ? Color(this.colourScheme?.primary).luminosity() > 0.7 ? 'black' : 'white' : null;
      this.secondaryColourText = this.colourScheme?.secondary ? Color(this.colourScheme?.secondary).luminosity() > 0.7 ? 'black' : 'white' : null;
    }

  }

  public toggleSection(section: any): void {
    this.sectionTitle = section.title;
    this.currentSection = section;
    this.cd.detectChanges();
  }

  public openItemModal(item: MenuItemInput) {
   this.modalService.open(DownloadModalComponent, {
      width: "500px"
    });
  }

  convertIcon(icon?: string) {
    if (icon) {
      const varName = icon.replace('-', '_');
      return this.icons[varName];
    } else {
      return null;
    }
  }
}


// public entity: any;

// $menu: Observable<MenuInput>;
// $currentSection = new BehaviorSubject<any>(null);
// $sections: Observable<MenuSectionInput[]>;

// sectionTitle: string;
// imageurl = environment.aws.s3Url + 'entities/';
// subscribing: number;
// currency: CurrencyInput;
// menuTitle: string;
// public search: string;

// constructor(private menuService: MenuService,
//   public modalController: ModalController,
//   private cd: ChangeDetectorRef,
//   private errorHandler: ErrorHandlerService,
//   public trackByService: TrackByService,
//   private utils: UtilitiesService) { }

// ngOnInit() {
//   this.$sections = this.menuService.getMenu(this.entity.id)
//     .pipe(
//       filter(isNotEmpty),
//       switchMap((menu: IMenu) => {
//       this.currency = menu.publisher.currency;
//       if (menu && menu.sections.length) {
//         this.menuTitle = menu.title;
//         this.cd.detectChanges();
//         this.toggleSection(menu.sections[0]);
//         return of(menu.sections);
//       } else {
//         this.modalController.dismiss();
//         this.utils.showToast('Looks like this menu isnt quite ready yet!', 3000, 'Empty Menu!');
//         return of(null);
//       }
//     }), catchError(err => {
//       this.modalController.dismiss();
//       this.errorHandler.handleError(err, 'Looks like this menu isnt quite ready yet!');
//       return of(null);
//     }));

//     this.$sections.subscribe();
// }

// public toggleSection(section: any): void {
//   this.sectionTitle = section.title;
//   this.$currentSection.next(section);
// }

// public async setNotify(index: number, item: any) {

//   item['subscribed'] = true;
//   this.cd.detectChanges();
// }

// public back(): void {
//   this.modalController.dismiss();
// }

// public async openItemModal(item: MenuItemInput): Promise<void> {
//   const modal: HTMLIonModalElement = await this.modalController.create({
//     componentProps: { item, currency: this.entity.currency },
//     component: MenuModalComponent,
//     cssClass: ' auto-height grow-shrink-modal',

//   });

//   modal.present();

// }
